<div class="m-wrapper">
    <span class="m-title ellipsis">{{title}}</span>
    <span>
        <button mat-dialog-close mat-icon-button>
            <mat-icon >close</mat-icon>
        </button>
    </span>
</div>
<mat-divider></mat-divider>
<div class="map-wrapper">
    <div id="map" class="map-body">
    </div>
</div>